export default "__VITE_ASSET__Bifhcxmn__"